import { requestorHelperService } from '@/requestors/requestor-helper-service.js';
import _ from 'lodash';

function getSlideRequest (data, title, subtitle, settings) {
    let chartSlide = { SlideType: 'bubble-chart', ChartRequests: [] };
    chartSlide.Title = title || 'Pillar Score SWOT (scaled)';
    chartSlide.Subtitle = subtitle;

    if (data) {
        chartSlide.ChartRequests.push(buildChartRequests(data, settings));
    }

    return chartSlide;
}

function buildChartRequests (data, settings) {
    let chartRequest = { Series: [], Legends: [] };
    chartRequest.YAxisTitle = settings.yAxis.label;
    chartRequest.XAxisTitle = settings.xAxis.label;

    let seriesIndex = 0;
    if (data) {
        settings.series.forEach(s => {
            let currentSeriesData = _.filter(data, d => d.columnId === s.id);

            chartRequest.Series.push({
                Index: seriesIndex,
                Name: s.name,
                Colour: s.colour,
                SeriesShape: 'Circle',
                SeriesData: _.map(currentSeriesData, d => ({
                    Category: d.day,
                    YValue: d.yQuality / 100.0, // because we're treating them as percentages on the pptx side
                    XValue: d.xConversation / 100.0,
                    Value: d.zCommunity / 100.0
                }))
            });

            chartRequest.Legends.push({
                Id: seriesIndex,
                Name: s.name,
                Colour: s.colour
            });
            seriesIndex++;
        });
    }
    return chartRequest;
}

class FinalScoreSnapshotRequestor {
    generatePPTXRequest (data, title, subtitle, settings) {
        return requestorHelperService.buildPresentationRequest(getSlideRequest, 'pillar_score_swot_scaled.pptx', data, title, subtitle, settings);
    }

    getSlideRequest (data, title, subtitle, settings) {
        return getSlideRequest(data, title, subtitle, settings);
    }
}

export const finalScoreSnapshotRequestor = new FinalScoreSnapshotRequestor();
